import {
  getData,
  setData,
  TASK_DETAILS_EXPANDED_VIEW
} from '../../models/LocalStorage';

export const getStoredExpandedTaskView = (): boolean =>
  getData(TASK_DETAILS_EXPANDED_VIEW) === true;

export const setStoredExpandedTaskView = (expanded: boolean): void => {
  setData(TASK_DETAILS_EXPANDED_VIEW, expanded);
};
